export function parseIntOrNull(value: number | string) {
  if (typeof value === 'number') return value;

  if (value === null || value === undefined || value === '') return null;

  return parseInt(value);
}

export function parseBoolelan(value: any, options?: { returnNull?: boolean }): boolean | null {
  if (options?.returnNull && (value === null || value === undefined)) return null;

  if (!value) return false;

  const type = typeof value;
  switch (type) {
    case 'boolean':
      return !!value;

    case 'string': {
      if (['true', '1'].includes(value.toLowerCase())) {
        return true;
      } else if (['false', '0'].includes(value.toLowerCase())) {
        return false;
      } else {
        throw `Invalid boolean string: ${value}`;
      }
    }

    case 'number': {
      if (value === 1) return true;
      else if (value === 0) return false;
      else throw `Invalid number for boolean: ${value}`;
    }

    default:
      throw `Unable to parse type ${type} to boolean.`;
  }
}

export function parseBoolelanOrNull(value: any): boolean | null {
  return parseBoolelan(value, { returnNull: true });
}
